import {React, useState, useEffect} from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import headerImg from "../assets/globe.PNG";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Send} from "react-bootstrap-icons";

export const NavBar = () => {
    const [activeLink, setactiveLink] = useState('home');
    const [scrolled, setscrolled] = useState(false);
    

    useEffect(() => {
        const onScroll = () =>{
            if (window.scrollY > 50){
                setscrolled(true);
            }
            else{
                setscrolled(false);
            }
        }
        window.addEventListener('scroll', onScroll);
        
        return () => window.removeEventListener('scroll', onScroll);
    }, [])

            
    const onUpdateActiveLink = (value) =>{
        setactiveLink(value);
    }

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      };
      

  return (
    <Navbar className="justify-content-center nav-class">
      <Container>
        <Navbar.Brand href="#home">
            <img src={headerImg} alt="Header of Me" style={{ width: '80px', height: '80px', paddingBottom: '10px' }}  className="header-image"/>
        </Navbar.Brand>
        <Nav className="justify-content-center d-none d-lg-flex">
            <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} 
                onClick = {() => onUpdateActiveLink('home')}>Home</Nav.Link>
            <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} 
                onClick = {() => onUpdateActiveLink('about')}>About</Nav.Link>
            <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} 
                onClick = {() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
            <Nav.Link href="#experience" className={activeLink === 'experience' ? 'active navbar-link' : 'navbar-link'} 
                onClick = {() => onUpdateActiveLink('experience')}>Experience</Nav.Link>
            <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} 
                onClick = {() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
          </Nav>
            <Button className="d-lg-block ml-auto custom-button" onClick={() => scrollToSection('contact-section')}>
                Contact Me <Send size={20}/>
            </Button>
      </Container>      
    </Navbar>
    
  );
};
